// extracted by mini-css-extract-plugin
module.exports = {"addContent":"word-skip-constructor_addContent__3zIzw","textPreview":"word-skip-constructor_textPreview__3eJ4n"};